import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLifestyleCalculator = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Ebene_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 -20 420 410",
	width: "100%",
	height: "100%",
	style: { enableBackground: "new 0 0 430 410" },
	xmlSpace: "preserve",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: "\n	.st0{opacity:6.000000e-02;}\n	.st1{fill:#1C145F;}\n	.st2{fill:#1259A7;}\n	.st3{opacity:0.2;enable-background:new    ;}\n	.st4{fill:#F0F0F0;}\n	.st5{fill:#FFFFFF;}\n	.st6{fill:#E0E0E0;}\n	.st7{fill:#EDD010;}\n	.st8{fill:#FEB19E;}\n	.st9{fill:#10275B;}\n	.st10{fill:#6B3FDC;}\n	.st11{opacity:0.7;fill:#EDD010;enable-background:new    ;}\n	.st12{fill:#ED893E;}\n	.st13{opacity:0.3;}\n	.st14{opacity:0.3;fill:#1C145F;enable-background:new    ;}\n	.st15{fill:#1259A7;stroke:#1259A7;stroke-miterlimit:10;}\n"
		}),
		/* @__PURE__ */ _jsx("g", {
			className: "st0",
			children: /* @__PURE__ */ _jsx("path", {
				className: "st1",
				d: "M206.5,385.9c114,0,206.4-5.4,206.4-12c0-6.7-92.4-12-206.4-12c-114,0-206.4,5.4-206.4,12 C0.1,380.5,92.5,385.9,206.5,385.9z"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st2",
			d: "M186.8,321.1c-1.1,0-2.3-0.2-3.3-0.7c-1-0.4-2-1.1-2.7-1.9c-0.8-0.8-1.4-1.8-1.7-2.9c-0.4-1.1-0.5-2.2-0.4-3.3 l20.9-273.9c0.2-2.4,1.3-4.6,3.1-6.2c1.8-1.6,4.1-2.6,6.4-2.6h172.9c1.1,0,2.3,0.2,3.3,0.7c1,0.4,2,1.1,2.7,1.9 c0.8,0.8,1.4,1.8,1.7,2.9c0.4,1.1,0.5,2.2,0.4,3.3l-20.9,273.9c-0.2,2.4-1.3,4.6-3.1,6.2c-1.8,1.6-4,2.6-6.4,2.6H186.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st3",
			d: "M358.4,75.7H234.7c-0.7,0-1.3-0.1-2-0.4c-0.6-0.3-1.2-0.7-1.6-1.2c-0.5-0.5-0.8-1.1-1-1.7 c-0.2-0.6-0.3-1.3-0.2-2c0.1-1.4,0.8-2.7,1.8-3.7c1-1,2.4-1.5,3.8-1.5h123.7c0.7,0,1.3,0.1,2,0.4c0.6,0.3,1.2,0.7,1.6,1.1 c0.5,0.5,0.8,1.1,1,1.7c0.2,0.6,0.3,1.3,0.2,2c-0.1,1.4-0.8,2.7-1.8,3.7C361.2,75.1,359.9,75.6,358.4,75.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st4",
			d: "M234.2,70.4c0.2-1.9,0-3.7-0.6-5.5c-0.6-1.8-1.6-3.4-2.8-4.7c-1.3-1.4-2.8-2.5-4.5-3.2 c-1.7-0.7-3.6-1.1-5.4-1.1h125.6c1.9,0,3.7,0.3,5.4,1.1c1.7,0.7,3.2,1.8,4.5,3.2c1.3,1.4,2.2,3,2.8,4.7c0.6,1.8,0.8,3.6,0.6,5.5 H234.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st5",
			d: "M220.8,55.9c-3.9,0.1-7.7,1.6-10.6,4.2c-2.9,2.7-4.7,6.3-5,10.2l-12.9,168.7c-0.3,3.9-2.1,7.6-5,10.2 c-2.9,2.7-6.6,4.2-10.6,4.2h125.6c3.9-0.1,7.7-1.6,10.6-4.2c2.9-2.7,4.7-6.3,5-10.2l12.9-168.7c0.3-3.9,2.1-7.6,5-10.2 c2.9-2.7,6.6-4.2,10.6-4.2H220.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st4",
			d: "M289,239.1c-0.2,1.9,0,3.7,0.6,5.5c0.6,1.8,1.6,3.4,2.8,4.7c1.3,1.4,2.8,2.4,4.5,3.2c1.7,0.7,3.6,1.1,5.4,1.1 H176.8c-1.9,0-3.7-0.3-5.4-1.1c-1.7-0.7-3.2-1.8-4.5-3.2c-1.3-1.4-2.2-3-2.8-4.7c-0.6-1.8-0.8-3.6-0.6-5.5H289z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st6",
			d: "M215.5,235.8c0.5-6.2-1.5-11.1-7.6-11.1h96.7c6.2,0,10.8,5.6,7.6,11.1H215.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st4",
			d: "M289,239.1c0.3-3.9,2.1-7.6,5-10.2c2.9-2.7,6.6-4.2,10.6-4.3H179c-3.9,0.1-7.7,1.6-10.6,4.2 c-2.9,2.7-4.7,6.3-5,10.2L289,239.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st5",
			d: "M348.4,280.9H204.2c-0.5,0-1-0.1-1.4-0.3c-0.4-0.2-0.9-0.5-1.2-0.8c-0.3-0.4-0.6-0.8-0.7-1.2 c-0.2-0.5-0.2-1-0.2-1.4c0.1-1,0.6-2,1.3-2.7c0.8-0.7,1.7-1.1,2.8-1.1H349c0.5,0,1,0.1,1.4,0.3c0.4,0.2,0.8,0.5,1.2,0.8 c0.3,0.4,0.6,0.8,0.7,1.2c0.2,0.5,0.2,0.9,0.2,1.4c-0.1,1-0.6,2-1.3,2.7C350.4,280.5,349.4,280.9,348.4,280.9z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st5",
			d: "M275.6,299.2h-72.8c-0.5,0-1-0.1-1.4-0.3c-0.4-0.2-0.9-0.5-1.2-0.8c-0.3-0.4-0.6-0.8-0.7-1.2 c-0.2-0.5-0.2-1-0.2-1.4c0.1-1,0.6-2,1.3-2.7c0.8-0.7,1.7-1.1,2.8-1.1h72.8c0.5,0,1,0.1,1.4,0.3c0.4,0.2,0.9,0.5,1.2,0.8 c0.3,0.4,0.6,0.8,0.7,1.2c0.2,0.5,0.2,1,0.2,1.4c-0.1,1-0.6,2-1.3,2.7C277.6,298.8,276.6,299.1,275.6,299.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st5",
			d: "M325.9,299.2h-29.5c-0.5,0-1-0.1-1.4-0.3c-0.4-0.2-0.9-0.5-1.2-0.8c-0.3-0.4-0.6-0.8-0.7-1.2 c-0.2-0.5-0.2-1-0.2-1.4c0.1-1,0.6-2,1.3-2.7c0.8-0.7,1.7-1.1,2.8-1.1h29.5c0.5,0,1,0.1,1.4,0.3c0.4,0.2,0.8,0.5,1.2,0.8 c0.3,0.4,0.6,0.8,0.7,1.2c0.2,0.5,0.2,1,0.2,1.4c-0.1,1-0.6,2-1.3,2.7C328,298.8,327,299.1,325.9,299.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st7",
			d: "M315.4,129.4H211.6l0.2-2.9h103.8L315.4,129.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st7",
			d: "M270.7,116h-56.8l0.3-4.3H271L270.7,116z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st4",
			d: "M315.4,129.4H211.6l-0.7,8.8h103.8L315.4,129.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st4",
			d: "M314.1,147H210.3l-0.7,8.8h103.8L314.1,147z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st4",
			d: "M312.7,164.6H208.9l-0.7,8.8h103.8L312.7,164.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st4",
			d: "M311.4,182.3H207.6l-0.7,8.8h103.8L311.4,182.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st7",
			d: "M309.8,202.8H206l0.2-2.9h103.8L309.8,202.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st4",
			d: "M298,75.7h21.6l-1,12.9H297L298,75.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st8",
			d: "M86.4,157.5l3.9,1.5c1.4,0.6,2.6,1.5,3.6,2.7l1.8,2.2c0.6,0.7,0.9,1.6,0.8,2.5c0,0.9-0.4,1.8-1,2.5l-1.9,2.1 c-0.3,0.4-0.8,0.7-1.2,0.9c-0.5,0.2-1,0.4-1.5,0.4c-0.5,0-1,0-1.5-0.2c-0.5-0.2-0.9-0.4-1.3-0.8l-1.8-1.6c0,0-5.5-3.9-7.2-9l1.1-1.1 c0.8-0.8,1.8-1.5,2.9-1.9C84.1,157.5,85.3,157.4,86.4,157.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st8",
			d: "M97,120.2l-1.3,0.8l-1.4,1c-0.9,0.7-1.9,1.3-2.8,2c-1.8,1.4-3.6,2.9-5.2,4.4c-3.2,2.9-6,6.3-8.2,10 c-0.3,0.4-0.5,0.9-0.7,1.4l-0.2,0.3c0-0.1,0.1-0.3,0.1-0.4c0-0.2,0-0.4,0-0.5c-0.1-0.3-0.1,0.5,0.1,1.3c0.7,2,1.5,4,2.5,5.9 c2.2,4.2,4.9,8.5,7.5,12.8l0.1,0.1c0.5,0.8,0.7,1.9,0.4,2.8c-0.2,1-0.8,1.8-1.7,2.3c-0.7,0.4-1.4,0.6-2.2,0.5 c-0.8,0-1.5-0.3-2.1-0.8c-2.1-1.7-4.2-3.4-6.1-5.3c-2-1.9-3.8-3.9-5.6-6.1c-1.9-2.3-3.6-4.9-4.9-7.6c-0.4-0.8-0.7-1.7-1-2.6 c-0.4-1.2-0.5-2.4-0.6-3.6c0-0.8,0.1-1.6,0.3-2.4c0.1-0.5,0.2-0.9,0.4-1.4l0.2-0.5c0.3-0.7,0.6-1.4,0.9-2.1 c2.5-5.4,5.9-10.4,10.2-14.6c2-2,4.1-4,6.4-5.7c1.1-0.9,2.3-1.7,3.4-2.5c0.6-0.4,1.2-0.8,1.8-1.2l0.9-0.6l1.1-0.6 c1.7-0.9,3.6-1.1,5.5-0.6c1.8,0.5,3.4,1.7,4.4,3.3c1,1.6,1.3,3.5,1,5.4c-0.4,1.9-1.5,3.5-3,4.6L97,120.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st2",
			d: "M97.1,103.3c-6.2,0-13,2.7-21.8,13.5c0,6.5,13.6,15.1,13.6,15.1S111.3,103.2,97.1,103.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st1",
			d: "M50.9,359.2c-0.1,0-0.2,0-0.3-0.1c-1.3-0.5-2.5-3.7-2.6-5.6c0-0.1,0-0.1,0-0.2c0,0,0.1-0.1,0.1-0.1 c0,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0.1,3.3,2.7,3.5,4.5c0,0.2,0,0.3,0,0.5c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.2,0.2-0.3,0.3 C51.2,359.1,51.1,359.1,50.9,359.2z M48.7,354.2c0.3,1.7,1.3,4,2.1,4.3c0.1,0,0.2,0,0.3,0c0.1,0,0.2-0.1,0.2-0.2 c0.1-0.1,0.1-0.2,0.1-0.2c0-0.1,0-0.2,0-0.3C51.3,356.8,49.7,355.2,48.7,354.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st1",
			d: "M52.9,355.2c-1.7-0.1-3.3-0.6-4.8-1.5c0,0-0.1-0.1-0.1-0.1c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0.1-0.2 c0,0,0.1-0.1,0.1-0.1c0.2,0,4.2-1.1,5.7-0.2c0.2,0.1,0.3,0.2,0.4,0.3c0.1,0.1,0.2,0.3,0.2,0.5c0.1,0.2,0,0.4,0,0.6 c-0.1,0.2-0.2,0.4-0.4,0.5C53.8,355.2,53.3,355.3,52.9,355.2z M49.1,353.6c1.6,0.8,4,1.3,4.7,0.8c0.1-0.1,0.2-0.2,0.1-0.5 c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.1-0.1-0.1-0.2-0.2C52.7,353,50.5,353.4,49.1,353.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st7",
			d: "M37,352.8c3.2-3.4,5.8-7.2,7.9-11.3c0,0,9.9,2.4,7.9,5.3c-3.5,5.2-5.2,15.8-0.7,21.5c2.6,3.2-1.5,3.8-4.3,2.4 c-4.3-2.2-4.1-3-6.4-6.7c-1.9-3.1-2.7-4.3-5.3-5.7C34.1,357.2,35.1,355,37,352.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st9",
			d: "M120.7,167.5c0,0-14.3,69.8-24.8,99.7c-11,31.3-41.4,79.6-42.6,81.7c-4.3-1.2-8.2-2.7-10.7-5.2 c0,0,14.3-52.4,28.2-86.4c5.3-71,16.9-89.8,16.9-89.8L120.7,167.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st3",
			d: "M98.9,204.8c-0.6,13.5-1.1,32.1-0.5,54.7c4.4-14.1,9.1-33.2,13.1-50.3C108.9,205.6,104.7,203.9,98.9,204.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st8",
			d: "M99.8,81.8c1.5,6.1,3,16,0.6,21.3c0,0,9,0.4,20.4,9.6c5.4-7.9-0.9-9.5-0.9-9.5c-4.8-1.1-4.5-7.5-4.5-12 L99.8,81.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st10",
			d: "M97.5,105.8c-4.5-0.5-1.4-9,0.9-8.2c5.9,2.1,19.1-0.2,23.1,2c4.1,2.2,3,6.9,3,6.9S102.3,106.4,97.5,105.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st11",
			d: "M97.5,105.8c-4.5-0.5-1.4-9,0.9-8.2c5.9,2.1,19.1-0.2,23.1,2c4.1,2.2,3,6.9,3,6.9S102.3,106.4,97.5,105.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st1",
			d: "M123.6,71.1c0.1,0.8,0.7,1.4,1.2,1.3c0.5-0.1,0.8-0.8,0.7-1.6c-0.1-0.8-0.7-1.4-1.2-1.3 C123.7,69.6,123.5,70.3,123.6,71.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st1",
			d: "M124.1,69.6l1.9-0.9C125.9,68.7,125.2,70.4,124.1,69.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st1",
			d: "M124.7,64.6c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.2-0.1-0.4,0 c-0.7,0.2-1.4,0.5-2,1c-0.6,0.5-1,1.1-1.3,1.9c0,0.1,0,0.3,0,0.4c0.1,0.1,0.2,0.2,0.3,0.2c0.1,0,0.3,0,0.4,0 c0.1-0.1,0.2-0.2,0.2-0.3c0.2-0.6,0.6-1.1,1.1-1.5c0.5-0.4,1-0.7,1.6-0.8c0.1,0,0.1,0,0.2-0.1C124.6,64.7,124.6,64.7,124.7,64.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st12",
			d: "M124.5,73.1c0.9,1.8,2.1,3.5,3.5,4.9c-0.4,0.3-0.8,0.6-1.3,0.7c-0.5,0.1-1,0.2-1.5,0.1L124.5,73.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st8",
			d: "M95.8,70.7c2.4,9.9,3.2,14.1,9,18.3c8.8,6.4,20.2,1.3,20.7-9c0.5-9.3-3.4-23.9-13.7-26.2 C101.5,51.6,93.4,60.8,95.8,70.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st9",
			d: "M114.9,72.5c5.8-7.7,9.6-13.9,6.7-20.7c-2.4-5.7-9-4-10-1.2c-17.6-1.5-24,4.9-20.3,15.4 c2.3,6.7-6.7,3.2-4.5,11.8c1.7,6.6-4.3,9.1-1.2,12.8c4.3,5.4,13.3-1.6,23.5,2.4C117.6,96.5,130.1,91.4,114.9,72.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st8",
			d: "M114,74.1c0.5,0.8,1.1,1.5,1.9,2c0.8,0.5,1.6,0.9,2.5,1c2.3,0.3,3.1-2.3,2.1-4.7c-0.9-2.1-3.1-4.9-5.3-4.2 C113.1,69.1,112.7,72,114,74.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st1",
			d: "M117.4,365.7c-1.9-0.2-3.6-1-5-2.2c0,0-0.1-0.1-0.1-0.1c0-0.1,0-0.1,0-0.2c0-0.1,0.1-0.1,0.1-0.1 c0,0,0.1-0.1,0.2-0.1c0.2,0,4.3-0.5,5.7,0.7c0.1,0.1,0.3,0.2,0.3,0.4c0.1,0.2,0.1,0.3,0.1,0.5c0,0.2,0,0.4-0.1,0.6 c-0.1,0.2-0.3,0.3-0.5,0.4C117.9,365.7,117.7,365.7,117.4,365.7z M113.4,363.5c1.4,1,3.8,1.9,4.5,1.5c0.1-0.1,0.2-0.2,0.2-0.4 c0-0.1,0-0.2-0.1-0.3c0-0.1-0.1-0.2-0.2-0.2C117.1,363.4,114.8,363.4,113.4,363.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st1",
			d: "M112.6,363.6c0,0-0.1,0-0.1,0c0,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0.1-0.1,2.1-3.7,3.9-4.2 c0.2-0.1,0.3-0.1,0.5,0c0.2,0,0.3,0.1,0.5,0.2c0.2,0.1,0.3,0.3,0.4,0.4c0.1,0.2,0.1,0.4,0.1,0.6 C117.5,361.5,114.4,363.2,112.6,363.6L112.6,363.6z M116.6,359.5h-0.2c-1,0.3-2.4,2.1-3.1,3.3c1.7-0.6,3.7-1.9,3.9-2.8 c0-0.1,0-0.3-0.2-0.4C116.8,359.5,116.7,359.5,116.6,359.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st7",
			d: "M125.3,369.4c-8.6-0.7-14.4-6.6-13.8-12.9c0.3-3.5-10.7-3.8-10.7-3.8c1.7,10.7-0.4,12.2-1.2,15 c-0.7,2.8-0.5,5.8,1.7,5.9c2.7,0.1,4-0.4,7.4-0.3c4,0.2,8.3,0.3,15.4,0.3C127,373.7,129.2,369.7,125.3,369.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st9",
			d: "M135.6,167.5c0,0-0.8,52.9-4.9,87.6c-4.2,34.8-18.5,102.9-18.5,102.9c-3.8,0.9-7.7,0.9-11.5-0.1 c0,0-4.5-53.2,3.1-104.7c-5.6-53.9-9.1-85.7-9.1-85.7H135.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st2",
			d: "M137.6,118.5c-0.2,4.1,6.3,13.5-1.7,19c1.5,3.3,2.7,25.9-0.3,29.9c-4.4,3.2-28.2,2.6-47.9,0 c-0.8-8.2,3.7-25-1.9-51.4c-0.3-1.4-0.3-2.9,0-4.4c0.3-1.4,0.9-2.8,1.8-4c0.9-1.2,2-2.2,3.3-2.9c1.3-0.7,2.7-1.2,4.2-1.3 c1.7-0.2,3.4-0.3,5.2-0.4c6.3-0.4,12.6-0.4,18.9,0c2,0.2,4.1,0.4,6.2,0.7c3.5,0.5,6.7,2.3,9,5S137.8,115,137.6,118.5z"
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "st13",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "st14",
					d: "M100.8,164.4c0,1.1,0.8,2.8,1.4,4.6l0.8,0.1C102.8,167.7,101.9,166.2,100.8,164.4z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "st14",
					d: "M105,169.2l1.6,0.1C106.1,169.1,105.5,169,105,169.2z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "st14",
					d: "M136,166.9c0-0.1,0.1-0.1,0.1-0.2l-0.4-0.1l-0.2-0.1c0.3-0.1,0.6-0.2,0.8-0.4c0.1-0.3,0.2-0.6,0.3-0.9 c-0.4,0.4-0.8,0.8-1.3,1.2l-1.2-0.4c1-0.1,1.5-1.1,2.3-2.5c-0.6,0.3-1.5,1.6-2.4,2.4l-0.4-0.2l-0.7-0.3c1.1-0.2,1.6-1.2,2.4-2.7 c-0.7,0.4-1.6,1.7-2.6,2.6l-1.3-0.6c1.1-0.2,1.7-1.3,2.6-2.7c-0.8,0.3-1.8,1.7-2.9,2.6l-1-0.5c1.2-0.2,1.9-1.4,2.9-3 c-0.8,0.4-2,1.9-3.2,2.8l-0.3-0.1l-1.3-0.7c1.2-0.2,2.1-1.4,3.4-3c-0.9,0.3-2.3,1.9-3.8,2.8c-0.5-0.3-1-0.6-1.4-0.8 c1.4-0.1,2.5-1.4,3.9-3.3c-1.1,0.4-2.6,2.1-4.3,3.1l-0.4-0.3c-0.4-0.3-0.8-0.6-1.3-0.9c1.5,0,2.8-1.4,4.4-3.3 c-1.1,0.3-3,2.1-4.8,3.1l-1.4-1c1.7,0.1,3.1-1.5,5-3.6c-1.3,0.4-3.3,2.4-5.2,3.4l-0.4-0.3c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0 c-0.1,0-0.1,0-0.2,0.1c0,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.1,0.1,0.2l0.4,0.3c0.1,2.2-0.6,5.1-0.2,6.3c0.9-2.7,1.5-4.6,0.6-6 c0.5,0.4,0.9,0.7,1.4,1c0.1,2.1-0.5,4.6-0.2,5.8c0.8-2.5,1.4-4.3,0.5-5.6c0.4,0.2,0.7,0.5,1.1,0.7l0.6,0.4c0,1.9-0.7,4.3-0.5,5.3 c0.9-2.3,1.5-3.9,0.7-5.2c0.5,0.3,1.1,0.6,1.5,0.8c0,1.8-0.7,3.9-0.5,4.9c0.8-2.1,1.4-3.6,0.7-4.8l1.3,0.7l0.3,0.2 c-0.1,1.6-0.9,3.5-0.8,4.4c0.9-1.9,1.6-3.2,0.9-4.4l1.3,0.6c-0.1,1.4-0.8,3.1-0.7,4h0.1c0.8-1.7,1.4-2.8,0.8-3.9l1.4,0.6 c-0.2,1.1-0.7,2.3-0.8,3.1l0.3-0.1c0.7-1.2,1.1-2.1,0.6-3l0.8,0.3l0.5,0.2c-0.1,0.8-0.3,1.5-0.6,2.2l0.5-0.1c0.2-0.3,0.3-0.6,0.4-1 c0-0.4,0-0.7-0.1-1l1.3,0.5c0,0.4-0.1,0.7-0.2,1.1c0.2-0.1,0.3-0.2,0.5-0.3c0-0.3-0.1-0.5-0.2-0.8l0.2,0.1L136,166.9z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "st14",
					d: "M95,144.8c0.1,0,0.1-0.1,0.2-0.1c0-0.1,0-0.1,0-0.2c0-0.1-0.1-0.1-0.1-0.2c-0.1,0-0.1,0-0.2,0l-0.5,0.2 c-1.9-1.2-3.7-3.5-5-3.9c1.6,2.3,2.8,3.9,4.5,4.1c-0.6,0.2-1.1,0.4-1.6,0.6c-1.3-0.8-2.5-2.1-3.6-3c0,0.2,0,0.5,0,0.7 c1.1,1.4,2,2.3,3.2,2.4c-0.4,0.1-0.8,0.3-1.2,0.5l-0.7,0.3c-0.5-0.3-0.9-0.7-1.3-1.1c0,0.3,0,0.6,0,0.9c0.3,0.2,0.7,0.3,1.1,0.3 l-1.1,0.5c0,0.1,0,0.3,0,0.4l1.4-0.6c-0.8,1.2-0.3,2.8,0.3,5.1c0.3-1.1-0.2-3.4,0-5.3l0.4-0.2l1.4-0.5c-0.9,1.2-0.5,3.1,0.1,5.6 c0.4-1.1,0-3.7,0.3-5.7c0.5-0.2,1.1-0.4,1.6-0.5c-1.1,1.4-0.6,3.3,0,6.2c0.5-1.2,0-4,0.3-6.2L95,144.8z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "st14",
					d: "M88.4,151.4c0,0.1,0.1,0.2,0.1,0.4c0.1-0.9,0.1-1.9,0-2.8C88.5,149.8,88.5,150.6,88.4,151.4z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "st14",
					d: "M92.2,167l-0.4-0.6c0.9-1.7,2.6-3.5,2.9-4.5c-1.9,1.7-3.2,2.8-3,4.3c-0.3-0.5-0.6-1-1-1.4 c0.8-1.6,2.4-3.2,2.6-4.2c-1.7,1.5-2.9,2.6-2.8,4l-0.9-1.2l-0.2-0.3c0.8-1.4,2.4-2.7,2.7-3.6c-1.7,1.2-2.9,2.1-2.8,3.5l-0.9-1.1 c0.8-1.3,2.2-2.5,2.5-3.3c-1.6,1.1-2.6,1.9-2.5,3.2l-0.7-0.8v0.4l0.4,0.5c-0.1,0-0.3-0.1-0.4-0.1c0,0.2,0,0.3,0,0.5l0.6-0.1 l0.7,0.9c-0.4-0.1-0.9-0.1-1.3,0v0.7c0.5-0.2,1-0.3,1.6-0.4l0.2,0.2l0.9,1.2c-0.9-0.2-1.8-0.1-2.6,0.4c0,0.2,0,0.4,0,0.6 c0.9-0.2,1.9-0.4,2.9-0.6c0.3,0.5,0.6,0.9,0.9,1.4c-1-0.5-2.1-0.1-3.7,0.5c0,0.1,0,0.3,0,0.4H88c1.2-0.3,2.4-0.5,3.6-0.7l0.3,0.4 l0.5,0.8l0.6,0.1C92.7,167.7,92.4,167.3,92.2,167z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "st14",
					d: "M88,157.3v0.5c0.3-0.3,0.6-0.6,0.7-1L88,157.3z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "st14",
					d: "M94.3,168.2l0.9,0.1c0.8-1.1,1.4-2.2,1.9-3.5C96.1,165.9,95.1,167,94.3,168.2z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "st14",
					d: "M93.2,168.2c0.9-1.8,2.4-3.7,2.7-4.8c-1.9,1.9-3.2,3.2-3,4.7L93.2,168.2z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "st14",
					d: "M87.9,159.2c0,0.3,0,0.6-0.1,0.8c0.8-0.7,1.4-1.5,2-2.4C89.2,158.1,88.5,158.6,87.9,159.2z"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st8",
			d: "M161.8,133.2l4.7-5l6.5,9.2c0,0-5.5,3.9-10.8,3.7l-0.6-1.4c-0.5-1-0.7-2.2-0.7-3.3 C161,135.3,161.2,134.2,161.8,133.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st8",
			d: "M174.1,128.7l1.8,3.5c0.4,0.8,0.5,1.6,0.2,2.5c-0.2,0.8-0.8,1.5-1.6,1.9l-1.5,0.8l-6.5-9.2l3.7-1.1 c0.7-0.2,1.5-0.2,2.2,0.1C173.1,127.5,173.7,128,174.1,128.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st8",
			d: "M137,115.3l0.4,2l0.4,2.1c0.3,1.4,0.6,2.9,1,4.3c0.7,2.9,1.5,5.7,2.4,8.4c0.9,2.6,1.9,5.1,3.2,7.6 c1,2,2.3,3.8,3.9,5.4L146,144c-0.7-0.1-0.8,0.1-0.4,0.1c0.6-0.1,1.1-0.2,1.6-0.5c1.6-0.7,3.1-1.6,4.5-2.6c1.6-1.1,3.2-2.3,4.8-3.6 c1.6-1.3,3.2-2.7,4.7-3.9l0.2-0.1c0.7-0.5,1.5-0.8,2.4-0.8c0.9,0,1.7,0.3,2.4,0.8c0.7,0.5,1.1,1.3,1.3,2.1c0.2,0.8,0.1,1.7-0.3,2.5 c-1.1,2-2.3,4-3.6,5.9c-1.3,1.9-2.8,3.8-4.3,5.5c-1.7,1.9-3.6,3.6-5.7,5.1c-1.3,0.9-2.8,1.6-4.3,2.1c-1,0.3-2,0.6-3,0.7 c-1.3,0.1-2.5,0-3.8-0.3c-0.7-0.2-1.4-0.5-2-0.9l-0.3-0.2c-3.3-2.4-6-5.5-8.1-9c-1-1.6-1.8-3.2-2.6-4.8c-0.8-1.6-1.5-3.2-2.1-4.8 c-1.2-3.2-2.3-6.4-3.1-9.7c-0.4-1.6-0.8-3.3-1.1-4.9c-0.2-0.8-0.3-1.6-0.5-2.5c-0.1-0.8-0.3-1.6-0.4-2.6c-0.2-1.9,0.3-3.8,1.4-5.4 c1.2-1.5,2.9-2.6,4.8-2.9c1.9-0.3,3.9,0.1,5.4,1.2c1.6,1.1,2.7,2.8,3.1,4.6L137,115.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st15",
			d: "M126.8,104.1c6.2,0.6,11.1,4.7,14.6,17.8c-2.7,3.7-19.4,11.8-19.4,11.8S112.6,102.6,126.8,104.1z"
		})
	]
});
const ForwardRef = forwardRef(SvgLifestyleCalculator);
export default ForwardRef;
